export default "__VITE_ASSET__Do6ER$Mv__"